import { FormControlledInput } from '@cocoonspace/ui/components/form-controlled-input'
import { useLingui } from '@lingui/react/macro'

import { useProfileFormContext } from '../use-profile-form.hook'
import { ImagePicker } from './image-picker'

const compactFieldClassNames = {
	formItem: 'pb-3',
	formMessage: 'relative',
}

export const ProfileCustomizationFields = () => {
	const { t } = useLingui()
	const form = useProfileFormContext()

	return (
		<>
			<FormControlledInput
				label={t`Image de bannière`}
				name='styles.bannerImageUrl'
				classNames={compactFieldClassNames}
				render={({ field }) => (
					<ImagePicker
						kind='banner'
						outputSize={{ width: 1400, height: 220 }}
						value={field.value ?? ''}
						preview={form.watch('bannerPreview')}
						onChange={(value) => {
							field.onChange(value)
							if (!value) form.setValue('bannerPreview', '')
						}}
						onPreviewChange={(value) => form.setValue('bannerPreview', value)}
					/>
				)}
			/>

			<FormControlledInput
				label={t`Logo`}
				name='styles.logoUrl'
				classNames={compactFieldClassNames}
				render={({ field }) => (
					<ImagePicker
						kind='logo'
						outputSize={500}
						value={field.value ?? ''}
						preview={form.watch('logoPreview')}
						onChange={(value) => {
							field.onChange(value)
							if (!value) form.setValue('logoPreview', '')
						}}
						onPreviewChange={(value) => form.setValue('logoPreview', value)}
					/>
				)}
			/>

			<FormControlledInput
				label={t`Image de fond`}
				name='styles.backgroundImageUrl'
				classNames={compactFieldClassNames}
				render={({ field }) => (
					<ImagePicker
						kind='background'
						outputSize={{ width: 1600, height: 900 }}
						value={field.value ?? ''}
						preview={form.watch('backgroundPreview')}
						onChange={(value) => {
							field.onChange(value)
							if (!value) form.setValue('backgroundPreview', '')
						}}
						onPreviewChange={(value) =>
							form.setValue('backgroundPreview', value)
						}
					/>
				)}
			/>
		</>
	)
}
